
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.4","height":"22","data-name":"グループ 562"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#12b6d4","d":"M13.2 22a1.1 1.1 0 01-1.1-1.1v-2.755H9.072A9.072 9.072 0 019.072 0h8.255A9.092 9.092 0 0126.4 8.994v.078a9.083 9.083 0 01-8.816 9.069l-3.612 3.543A1.1 1.1 0 0113.2 22M9.072 2.2a6.867 6.867 0 100 13.735H13.2a1.1 1.1 0 011.1 1.1v1.229l2.055-2.016a1.1 1.1 0 01.772-.316h.2a6.875 6.875 0 006.873-6.86v-.035A6.882 6.882 0 0017.328 2.2z","data-name":"パス 744"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M7.82 7.685A1.345 1.345 0 109.162 9.03a1.345 1.345 0 00-1.344-1.345","data-name":"パス 745"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M13.199 7.685a1.345 1.345 0 101.345 1.345 1.345 1.345 0 00-1.345-1.345","data-name":"パス 746"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M18.579 7.685a1.345 1.345 0 101.345 1.345 1.345 1.345 0 00-1.345-1.345","data-name":"パス 747"}})])
          )
        }
      }
    